var _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import "core-js/modules/es.array.reverse.js";
import "core-js/modules/web.dom-collections.iterator.js";
import { action, makeObservable, observable } from "mobx";
import Cartographic from "terriajs-cesium/Source/Core/Cartographic";
import HeadingPitchRoll from "terriajs-cesium/Source/Core/HeadingPitchRoll";
import JulianDate from "terriajs-cesium/Source/Core/JulianDate";
import CesiumMath from "terriajs-cesium/Source/Core/Math";
import GltfMixin from "../../lib/ModelMixins/GltfMixin";
import CommonStrata from "../../lib/Models/Definition/CommonStrata";
import CreateModel from "../../lib/Models/Definition/CreateModel";
import updateModelFromJson from "../../lib/Models/Definition/updateModelFromJson";
import Terria from "../../lib/Models/Terria";
import GltfTraits from "../../lib/Traits/TraitsClasses/GltfTraits";
describe("GltfMixin", function () {
  let terria;
  beforeAll(function () {
    terria = new Terria();
  });
  it("recomputes `mapItems` when `gltfModelUrl` changes", action(function () {
    var _entity$model;
    const testItem = new TestGltfItem("test", terria);
    expect(testItem.mapItems).toEqual([]);
    testItem.gltfModelUrl = "http://example.org/test.glb";
    const dataSource = testItem.mapItems[0];
    expect(dataSource).toBeDefined();
    const entity = dataSource.entities.values[0];
    expect(entity === null || entity === void 0 || (_entity$model = entity.model) === null || _entity$model === void 0 || (_entity$model = _entity$model.uri) === null || _entity$model === void 0 ? void 0 : _entity$model.getValue(JulianDate.now())).toEqual("http://example.org/test.glb");
  }));
  it("correctly sets the model parameters", action(function () {
    var _testItem$mapItems$;
    const testItem = new TestGltfItem("test", terria);
    expect(testItem.mapItems).toEqual([]);
    testItem.gltfModelUrl = "http://example.org/test.glb";
    updateModelFromJson(testItem, CommonStrata.user, {
      origin: {
        latitude: 42,
        longitude: 42,
        height: 42
      },
      rotation: {
        heading: 42,
        pitch: 42,
        roll: 42
      },
      scale: 42
    });
    const entity = (_testItem$mapItems$ = testItem.mapItems[0]) === null || _testItem$mapItems$ === void 0 ? void 0 : _testItem$mapItems$.entities.values[0];
    const modelGraphics = entity.model;
    expect(modelGraphics).toBeDefined();
    if (modelGraphics) {
      var _modelGraphics$scale, _entity$position, _entity$orientation;
      expect((_modelGraphics$scale = modelGraphics.scale) === null || _modelGraphics$scale === void 0 ? void 0 : _modelGraphics$scale.getValue(JulianDate.now())).toBe(42);

      // Compare lat,lon,height in degrees
      const position = Cartographic.fromCartesian((_entity$position = entity.position) === null || _entity$position === void 0 ? void 0 : _entity$position.getValue(JulianDate.now()));
      const lat = CesiumMath.toDegrees(position.latitude),
        lon = CesiumMath.toDegrees(position.longitude),
        height = position.height;
      expect(lat).toBeCloseTo(42);
      expect(lon).toBeCloseTo(42);
      expect(height).toBeCloseTo(42);

      // Compare heading,pitch,roll in degrees. Note that the trait values
      // are specified in local co-ordinates but when we set the values for
      // the entity we add the rotation from the center of the earth at the
      // entity position.
      const hpr = HeadingPitchRoll.fromQuaternion((_entity$orientation = entity.orientation) === null || _entity$orientation === void 0 ? void 0 : _entity$orientation.getValue(JulianDate.now()));
      const heading = CesiumMath.toDegrees(hpr.heading),
        pitch = CesiumMath.toDegrees(hpr.pitch),
        roll = CesiumMath.toDegrees(hpr.roll);
      expect(heading).toBeCloseTo(-75.6391, 3);
      expect(pitch).toBeCloseTo(4.485, 3);
      expect(roll).toBeCloseTo(75.6391, 3);
    }
  }));
  describe("disableZoomTo", function () {
    it("should disable zoom to when model position is not known", function () {
      const testItem = new TestGltfItem("test", terria);
      expect(testItem.disableZoomTo).toBeTruthy();
    });
    it("should enable zoom to when model position is known", function () {
      const testItem = new TestGltfItem("test", terria);
      updateModelFromJson(testItem, CommonStrata.user, {
        origin: {
          latitude: 42,
          longitude: 42,
          height: 42
        }
      });
      expect(testItem.disableZoomTo).toBeFalsy();
    });
  });
});
let TestGltfItem = (_class = class TestGltfItem extends GltfMixin(CreateModel(GltfTraits)) {
  constructor() {
    super(...arguments);
    _initializerDefineProperty(this, "gltfModelUrl", _descriptor, this);
    makeObservable(this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, "gltfModelUrl", [observable], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return undefined;
  }
}), _class);